// =============================================================================
// SINGLE SOURCE OF TRUTH for core business info — used both by the UI
// (Contact.jsx, Footer.jsx, etc.) and to auto-generate the static,
// AI/search-crawlable files: public/robots.txt, public/sitemap.xml,
// public/llms.txt, and the JSON-LD block in public/index.html.
//
// HOW AUTO-UPDATE WORKS: scripts/generate-seo.js reads this file (plus
// ORDER_TIERS/TIRE_CATEGORIES from ./tireSizes.js) and regenerates all of the
// files above every time `yarn start` or `yarn build` runs (see the
// "prestart"/"prebuild" hooks in package.json). If the business name,
// address, phone, services, or tire packages ever change, edit the source
// below — the static SEO files will catch up automatically on the next run.
// Do NOT hand-edit the generated files directly; they get overwritten.
// =============================================================================

export const SITE_CONTENT = {
  name: 'BulkUsedTires.com',
  tagline: 'Wholesale bulk used tires — international shipping, worldwide.',
  description:
    'BulkUsedTires.com is a wholesale used tire exporter shipping bulk-container loads of graded used tires (800, 1600 or 2400 units per order) worldwide — to Africa, Latin America, the Middle East, Asia-Pacific, and across the USA. We handle sorting, high-density tripled packing, and full freight/export documentation.',
  email: 'Bulkusedtires@gmail.com',
  phone: '+17402634680',
  phoneDisplay: '(740) 263-4680',
  address: {
    street: '116 South Norton St',
    city: 'Mt Vernon',
    state: 'OH',
    postalCode: '43050',
    country: 'US',
  },
  hours: 'Monday - Friday, 8:00 AM - 5:00 PM EST',
  services: [
    {
      name: 'High-Density Tripling & Packing',
      description: 'Specialized tripling techniques nest up to three tires inside one another, cutting per-unit shipping cost by up to 60%.',
    },
    {
      name: 'Rigorous Sorting & Grading',
      description: 'Manual and laser tread grading guarantees consistent quality across every container.',
    },
    {
      name: 'Freight & Container Shipping',
      description: 'Full 20ft and 40ft HC container loading coordinated through a worldwide partner network, with complete export documentation.',
    },
  ],
  // Paths that should never be indexed or crawled (private/account areas).
  privatePaths: ['/admin', '/account', '/login', '/sign', '/forgot-password', '/reset-password'],
};
